import {Injectable} from '@angular/core';
import {Http, ConnectionBackend, Request, RequestOptions, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Rx';
import {ErrorNotifierService} from '../error-notifier/error.notifier';
import {LoginService} from '../login/login.service';

@Injectable()
export class CustomHttp extends Http {
    err: any;

    constructor(backend: ConnectionBackend,
                defaultOptions: RequestOptions,
                private errorService: ErrorNotifierService) {
        super(backend, defaultOptions);
        this.err = null;
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<any> {
        // console.log('Before the request...');
        return super.request(url, options)
            .catch((err: any): any => {
                this.errorService.notifyError(err);

                return Observable.empty();
            })
            .retryWhen(error => error.delay(500))
            //.timeout(2000, new Error('delay exceeded'))
            .finally(() => {
                // console.log('After the request...');
            });
    }

    get(url: string, options?: RequestOptionsArgs): Observable<any> {
        var headers;
        this.err=null;
        if (this.err == null && url.indexOf("/reset") == -1) {
            if (options == undefined) {
                options = {};
                headers = new Headers();
            }
            else {
                headers = options.headers;
            }

            options.headers = this.createAuthorizationHeader(headers);
            return super.get(url, options)
                .catch((err: any): any => {
                    console.log(err);
                    if (err.status === 400 || err.status === 422) {
                        return Observable.throw(err);
                    } else {
                        this.errorService.notifyError(err);
                        return Observable.empty();
                    }
                })
                .retryWhen(error => error.delay(500))
                //.timeout(2000, new Error('delay exceeded'))
                .finally(() => {
                    // console.log('After the request...');
                });
        }
        else
            return super.get(url, options);
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        this.err = null;
        var headers;
        if (this.err == null && url.indexOf("/authenticate") == -1 && url.indexOf("/forgot") == -1) {
            if (options == undefined) {
                options = {};
                headers = new Headers();
            }
            else {
                headers = options.headers;
            }

            options.headers = this.createAuthorizationHeader(headers);
            return super.post(url, body, options)
                .catch((err: any): any => {
                    if (err.status === 400 || err.status === 422) {
                        return Observable.throw(err);
                    } else {
                        console.log(err);
                        console.log(err.status);
                        this.err = err;
                        this.errorService.notifyError(err);
                        //return Observable.empty();
                        return Observable.throw(err);
                    }
                })
                .finally(() => {
                    if (this.err == null)
                        this.errorService.notifyOk();
                });
        }
        else
            return super.post(url, body, options);
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        var headers;
        if (options == undefined) {
            options = {};
            headers = new Headers();
        }
        else {
            headers = options.headers;
        }

        options.headers = this.createAuthorizationHeader(headers);
        this.err = null;
        return super.put(url, body, options)
            .catch((err: any): any => {
                if (err.status === 400 || err.status === 422) {
                    return Observable.throw(err);
                } else {
                    this.err = err;
                    this.errorService.notifyError(err);
                    return Observable.empty();
                }
            })
            .finally(() => {
                if (this.err == null)
                    this.errorService.notifyOk();
            });
    }

    delete(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        var headers;
        if (options == undefined) {
            options = {};
            headers = new Headers();
        }
        else {
            headers = options.headers;
        }

        options.headers = this.createAuthorizationHeader(headers);
        this.err = null;
        return super.delete(url, options)
            .catch((err: any): any => {
                if (err.status === 400 || err.status === 422) {
                    return Observable.throw(err);
                } else {
                    this.err = err;
                    this.errorService.notifyError(err);
                    return Observable.empty();
                }
            })
            .finally(() => {
                if (this.err == null)
                    this.errorService.notifyOk();
            });
    }


    private createAuthorizationHeader(headers) {

        headers.append('Authorization', localStorage.getItem('jwtSGDI')
        );
        return headers;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/custom-http/custom.http.ts